<script setup lang="ts">
import BaseBadge from '@/components/ui/BaseBadge.vue';
import type { RepeatIssueDto } from '@/api/reports';

interface Props {
  repeats: RepeatIssueDto[];
}

defineProps<Props>();

type SeverityVariant = 'critical' | 'high' | 'medium' | 'low';

function severityVariant(sev: string): SeverityVariant {
  const s = sev.toLowerCase();
  if (s === 'critical') return 'critical';
  if (s === 'high') return 'high';
  if (s === 'medium') return 'medium';
  return 'low';
}
</script>

<template>
  <!-- AI badge rule: teal eyebrow on AI-detected content -->
  <div data-testid="report-repeat-issues">
    <div class="flex items-center gap-2 mb-3">
      <BaseBadge variant="ai" :no-dot="false">AI SUMMARY</BaseBadge>
      <span class="text-xs text-muted">Patterns flagged as recurring this month</span>
    </div>

    <div v-if="repeats.length === 0" class="text-sm text-muted py-2">
      No recurring patterns detected this month.
    </div>

    <ul v-else class="space-y-3">
      <li
        v-for="issue in repeats"
        :key="issue.title"
        class="border-l-4 border-l-teal-500 pl-3 py-1"
      >
        <div class="flex items-center gap-2 flex-wrap">
          <BaseBadge :variant="severityVariant(issue.severity)" :no-dot="false">
            {{ issue.severity }}
          </BaseBadge>
          <span class="text-sm font-medium text-fg">{{ issue.title }}</span>
          <span class="font-mono tabular-nums text-xs text-muted ml-auto">
            {{ issue.occurrenceCount }}× occurrences
          </span>
        </div>
        <div class="mt-1 font-mono tabular-nums text-xs text-muted">
          {{ issue.firstSeenDate }} → {{ issue.lastSeenDate }}
        </div>
      </li>
    </ul>
  </div>
</template>
